"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * partner-data
 * For managing partner-related data such as lists of featured demand partners for supply sub accounts, logos, etc.
 *
 * The version of the OpenAPI document: 1.6.0-rc.16
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyDemandInclusionApi = exports.SupplyDemandInclusionApiFactory = exports.SupplyDemandInclusionApiFp = exports.SupplyDemandInclusionApiAxiosParamCreator = exports.StateExclusionApi = exports.StateExclusionApiFactory = exports.StateExclusionApiFp = exports.StateExclusionApiAxiosParamCreator = exports.LifeInsurancePolicyDetailsApi = exports.LifeInsurancePolicyDetailsApiFactory = exports.LifeInsurancePolicyDetailsApiFp = exports.LifeInsurancePolicyDetailsApiAxiosParamCreator = exports.LifeInsuranceCarrierDetailsApi = exports.LifeInsuranceCarrierDetailsApiFactory = exports.LifeInsuranceCarrierDetailsApiFp = exports.LifeInsuranceCarrierDetailsApiAxiosParamCreator = exports.FeaturedDemandPartnersApi = exports.FeaturedDemandPartnersApiFactory = exports.FeaturedDemandPartnersApiFp = exports.FeaturedDemandPartnersApiAxiosParamCreator = exports.EnabledDemandSubAccountsApi = exports.EnabledDemandSubAccountsApiFactory = exports.EnabledDemandSubAccountsApiFp = exports.EnabledDemandSubAccountsApiAxiosParamCreator = exports.AvailableDemandPartnersApi = exports.AvailableDemandPartnersApiFactory = exports.AvailableDemandPartnersApiFp = exports.AvailableDemandPartnersApiAxiosParamCreator = exports.ActivePartnerFeaturesApi = exports.ActivePartnerFeaturesApiFactory = exports.ActivePartnerFeaturesApiFp = exports.ActivePartnerFeaturesApiAxiosParamCreator = exports.PartnerFeature = exports.Order = exports.LifeInsurancePolicyDeliveryMethod = exports.InclusionReason = exports.CarrierDecisionType = exports.ActivePartnerFeatureSortBy = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivePartnerFeatureSortBy = {
    Id: 'id',
    SubAccountId: 'subAccountId',
    Feature: 'feature'
};
/**
 * Decision type of carrier
 * @export
 * @enum {string}
 */
exports.CarrierDecisionType = {
    Instant: 'instant',
    NonInstant: 'non_instant'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InclusionReason = {
    DemandOnboarding: 'demand_onboarding',
    SupplyOnboarding: 'supply_onboarding',
    PoorPerformance: 'poor_performance',
    DemandRequest: 'demand_request',
    SupplyRequest: 'supply_request',
    Other: 'other'
};
/**
 * Delivery method of the policy
 * @export
 * @enum {string}
 */
exports.LifeInsurancePolicyDeliveryMethod = {
    Paper: 'paper',
    Electronic: 'electronic'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Order = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PartnerFeature = {
    NoRemarketing: 'no_remarketing',
    VantageScore4: 'vantage_score_4'
};
/**
 * ActivePartnerFeaturesApi - axios parameter creator
 * @export
 */
var ActivePartnerFeaturesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Activate a feature for a partner
         * @param {ActivePartnerFeatureCreateData} [activePartnerFeatureCreateData] A Partner Feature activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePartnerFeature: function (activePartnerFeatureCreateData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/activePartnerFeatures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activePartnerFeatureCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Deactive a feature for a partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePartnerFeature: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deactivatePartnerFeature', 'id', id);
                            localVarPath = "/activePartnerFeatures/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get currently active features
         * @param {number} limit
         * @param {number} [id]
         * @param {string} [uuid]
         * @param {Array<number>} [subAccountIds]
         * @param {PartnerFeature} [feature]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {string} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {number} [offset]
         * @param {ActivePartnerFeatureSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePartnerFeatures: function (limit, id, uuid, subAccountIds, feature, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getActivePartnerFeatures', 'limit', limit);
                            localVarPath = "/activePartnerFeatures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid !== undefined) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (subAccountIds) {
                                localVarQueryParameter['subAccountIds'] = subAccountIds;
                            }
                            if (feature !== undefined) {
                                localVarQueryParameter['feature'] = feature;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy !== undefined) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ActivePartnerFeaturesApiAxiosParamCreator = ActivePartnerFeaturesApiAxiosParamCreator;
/**
 * ActivePartnerFeaturesApi - functional programming interface
 * @export
 */
var ActivePartnerFeaturesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ActivePartnerFeaturesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Activate a feature for a partner
         * @param {ActivePartnerFeatureCreateData} [activePartnerFeatureCreateData] A Partner Feature activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePartnerFeature: function (activePartnerFeatureCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.activatePartnerFeature(activePartnerFeatureCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deactive a feature for a partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePartnerFeature: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deactivatePartnerFeature(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get currently active features
         * @param {number} limit
         * @param {number} [id]
         * @param {string} [uuid]
         * @param {Array<number>} [subAccountIds]
         * @param {PartnerFeature} [feature]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {string} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {number} [offset]
         * @param {ActivePartnerFeatureSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePartnerFeatures: function (limit, id, uuid, subAccountIds, feature, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActivePartnerFeatures(limit, id, uuid, subAccountIds, feature, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ActivePartnerFeaturesApiFp = ActivePartnerFeaturesApiFp;
/**
 * ActivePartnerFeaturesApi - factory interface
 * @export
 */
var ActivePartnerFeaturesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ActivePartnerFeaturesApiFp)(configuration);
    return {
        /**
         *
         * @summary Activate a feature for a partner
         * @param {ActivePartnerFeatureCreateData} [activePartnerFeatureCreateData] A Partner Feature activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePartnerFeature: function (activePartnerFeatureCreateData, options) {
            return localVarFp.activatePartnerFeature(activePartnerFeatureCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deactive a feature for a partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePartnerFeature: function (id, options) {
            return localVarFp.deactivatePartnerFeature(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get currently active features
         * @param {number} limit
         * @param {number} [id]
         * @param {string} [uuid]
         * @param {Array<number>} [subAccountIds]
         * @param {PartnerFeature} [feature]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {string} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {number} [offset]
         * @param {ActivePartnerFeatureSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePartnerFeatures: function (limit, id, uuid, subAccountIds, feature, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options) {
            return localVarFp.getActivePartnerFeatures(limit, id, uuid, subAccountIds, feature, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ActivePartnerFeaturesApiFactory = ActivePartnerFeaturesApiFactory;
/**
 * ActivePartnerFeaturesApi - object-oriented interface
 * @export
 * @class ActivePartnerFeaturesApi
 * @extends {BaseAPI}
 */
var ActivePartnerFeaturesApi = /** @class */ (function (_super) {
    __extends(ActivePartnerFeaturesApi, _super);
    function ActivePartnerFeaturesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Activate a feature for a partner
     * @param {ActivePartnerFeaturesApiActivatePartnerFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivePartnerFeaturesApi
     */
    ActivePartnerFeaturesApi.prototype.activatePartnerFeature = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ActivePartnerFeaturesApiFp)(this.configuration).activatePartnerFeature(requestParameters.activePartnerFeatureCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deactive a feature for a partner
     * @param {ActivePartnerFeaturesApiDeactivatePartnerFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivePartnerFeaturesApi
     */
    ActivePartnerFeaturesApi.prototype.deactivatePartnerFeature = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ActivePartnerFeaturesApiFp)(this.configuration).deactivatePartnerFeature(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get currently active features
     * @param {ActivePartnerFeaturesApiGetActivePartnerFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivePartnerFeaturesApi
     */
    ActivePartnerFeaturesApi.prototype.getActivePartnerFeatures = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ActivePartnerFeaturesApiFp)(this.configuration).getActivePartnerFeatures(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.subAccountIds, requestParameters.feature, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ActivePartnerFeaturesApi;
}(base_1.BaseAPI));
exports.ActivePartnerFeaturesApi = ActivePartnerFeaturesApi;
/**
 * AvailableDemandPartnersApi - axios parameter creator
 * @export
 */
var AvailableDemandPartnersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * A list of partners whose offers can be served to leads from the given supply sub account
         * @summary Retrieve a list of available demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartners: function (supplySubAccountId, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplySubAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableDemandPartners', 'supplySubAccountId', supplySubAccountId);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableDemandPartners', 'limit', limit);
                            localVarPath = "/availableDemandPartners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all available demand partners filtered by subAccountUuid of access token
         * @summary Get all available demand partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartnersByToken: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tokenAvailableDemandPartners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["svc-life-insurance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AvailableDemandPartnersApiAxiosParamCreator = AvailableDemandPartnersApiAxiosParamCreator;
/**
 * AvailableDemandPartnersApi - functional programming interface
 * @export
 */
var AvailableDemandPartnersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AvailableDemandPartnersApiAxiosParamCreator)(configuration);
    return {
        /**
         * A list of partners whose offers can be served to leads from the given supply sub account
         * @summary Retrieve a list of available demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartners: function (supplySubAccountId, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableDemandPartners(supplySubAccountId, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all available demand partners filtered by subAccountUuid of access token
         * @summary Get all available demand partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartnersByToken: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableDemandPartnersByToken(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AvailableDemandPartnersApiFp = AvailableDemandPartnersApiFp;
/**
 * AvailableDemandPartnersApi - factory interface
 * @export
 */
var AvailableDemandPartnersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AvailableDemandPartnersApiFp)(configuration);
    return {
        /**
         * A list of partners whose offers can be served to leads from the given supply sub account
         * @summary Retrieve a list of available demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartners: function (supplySubAccountId, limit, options) {
            return localVarFp.getAvailableDemandPartners(supplySubAccountId, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all available demand partners filtered by subAccountUuid of access token
         * @summary Get all available demand partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDemandPartnersByToken: function (options) {
            return localVarFp.getAvailableDemandPartnersByToken(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AvailableDemandPartnersApiFactory = AvailableDemandPartnersApiFactory;
/**
 * AvailableDemandPartnersApi - object-oriented interface
 * @export
 * @class AvailableDemandPartnersApi
 * @extends {BaseAPI}
 */
var AvailableDemandPartnersApi = /** @class */ (function (_super) {
    __extends(AvailableDemandPartnersApi, _super);
    function AvailableDemandPartnersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * A list of partners whose offers can be served to leads from the given supply sub account
     * @summary Retrieve a list of available demand partners
     * @param {AvailableDemandPartnersApiGetAvailableDemandPartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDemandPartnersApi
     */
    AvailableDemandPartnersApi.prototype.getAvailableDemandPartners = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AvailableDemandPartnersApiFp)(this.configuration).getAvailableDemandPartners(requestParameters.supplySubAccountId, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all available demand partners filtered by subAccountUuid of access token
     * @summary Get all available demand partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDemandPartnersApi
     */
    AvailableDemandPartnersApi.prototype.getAvailableDemandPartnersByToken = function (options) {
        var _this = this;
        return (0, exports.AvailableDemandPartnersApiFp)(this.configuration).getAvailableDemandPartnersByToken(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AvailableDemandPartnersApi;
}(base_1.BaseAPI));
exports.AvailableDemandPartnersApi = AvailableDemandPartnersApi;
/**
 * EnabledDemandSubAccountsApi - axios parameter creator
 * @export
 */
var EnabledDemandSubAccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand sub account enablement
         * @summary Create a demand sub account enablement
         * @param {EnabledDemandSubAccountCreateData} [enabledDemandSubAccountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnabledDemandSubAccount: function (enabledDemandSubAccountCreateData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/enabledDemandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(enabledDemandSubAccountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand sub account enablement
         * @summary Delete a demand sub account enablement
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnabledDemandSubAccount: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteEnabledDemandSubAccount', 'id', id);
                            localVarPath = "/enabledDemandSubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a demand sub account enablement
         * @summary Get a demand sub account enablement
         * @param {number} limit
         * @param {Array<number>} [subAccountIds] A comma separated list sub account ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccounts: function (limit, subAccountIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getEnabledDemandSubAccounts', 'limit', limit);
                            localVarPath = "/enabledDemandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (subAccountIds) {
                                localVarQueryParameter['subAccountIds'] = subAccountIds.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Replicate EnabledDemandSubAccounts
         * @summary Replicate EnabledDemandSubAccounts
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccountsReplicationPage: function (lastModified, id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'lastModified' is not null or undefined
                            (0, common_1.assertParamExists)('getEnabledDemandSubAccountsReplicationPage', 'lastModified', lastModified);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getEnabledDemandSubAccountsReplicationPage', 'id', id);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getEnabledDemandSubAccountsReplicationPage', 'limit', limit);
                            localVarPath = "/replication/enabledDemandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["internal"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (lastModified !== undefined) {
                                localVarQueryParameter['lastModified'] = (lastModified instanceof Date) ?
                                    lastModified.toISOString() :
                                    lastModified;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnabledDemandSubAccountsApiAxiosParamCreator = EnabledDemandSubAccountsApiAxiosParamCreator;
/**
 * EnabledDemandSubAccountsApi - functional programming interface
 * @export
 */
var EnabledDemandSubAccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnabledDemandSubAccountsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand sub account enablement
         * @summary Create a demand sub account enablement
         * @param {EnabledDemandSubAccountCreateData} [enabledDemandSubAccountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnabledDemandSubAccount: function (enabledDemandSubAccountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createEnabledDemandSubAccount(enabledDemandSubAccountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a demand sub account enablement
         * @summary Delete a demand sub account enablement
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnabledDemandSubAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteEnabledDemandSubAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a demand sub account enablement
         * @summary Get a demand sub account enablement
         * @param {number} limit
         * @param {Array<number>} [subAccountIds] A comma separated list sub account ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccounts: function (limit, subAccountIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnabledDemandSubAccounts(limit, subAccountIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Replicate EnabledDemandSubAccounts
         * @summary Replicate EnabledDemandSubAccounts
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccountsReplicationPage: function (lastModified, id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnabledDemandSubAccountsReplicationPage(lastModified, id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EnabledDemandSubAccountsApiFp = EnabledDemandSubAccountsApiFp;
/**
 * EnabledDemandSubAccountsApi - factory interface
 * @export
 */
var EnabledDemandSubAccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnabledDemandSubAccountsApiFp)(configuration);
    return {
        /**
         * Create a demand sub account enablement
         * @summary Create a demand sub account enablement
         * @param {EnabledDemandSubAccountCreateData} [enabledDemandSubAccountCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnabledDemandSubAccount: function (enabledDemandSubAccountCreateData, options) {
            return localVarFp.createEnabledDemandSubAccount(enabledDemandSubAccountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand sub account enablement
         * @summary Delete a demand sub account enablement
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnabledDemandSubAccount: function (id, options) {
            return localVarFp.deleteEnabledDemandSubAccount(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a demand sub account enablement
         * @summary Get a demand sub account enablement
         * @param {number} limit
         * @param {Array<number>} [subAccountIds] A comma separated list sub account ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccounts: function (limit, subAccountIds, options) {
            return localVarFp.getEnabledDemandSubAccounts(limit, subAccountIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Replicate EnabledDemandSubAccounts
         * @summary Replicate EnabledDemandSubAccounts
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDemandSubAccountsReplicationPage: function (lastModified, id, limit, options) {
            return localVarFp.getEnabledDemandSubAccountsReplicationPage(lastModified, id, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnabledDemandSubAccountsApiFactory = EnabledDemandSubAccountsApiFactory;
/**
 * EnabledDemandSubAccountsApi - object-oriented interface
 * @export
 * @class EnabledDemandSubAccountsApi
 * @extends {BaseAPI}
 */
var EnabledDemandSubAccountsApi = /** @class */ (function (_super) {
    __extends(EnabledDemandSubAccountsApi, _super);
    function EnabledDemandSubAccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand sub account enablement
     * @summary Create a demand sub account enablement
     * @param {EnabledDemandSubAccountsApiCreateEnabledDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnabledDemandSubAccountsApi
     */
    EnabledDemandSubAccountsApi.prototype.createEnabledDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EnabledDemandSubAccountsApiFp)(this.configuration).createEnabledDemandSubAccount(requestParameters.enabledDemandSubAccountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand sub account enablement
     * @summary Delete a demand sub account enablement
     * @param {EnabledDemandSubAccountsApiDeleteEnabledDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnabledDemandSubAccountsApi
     */
    EnabledDemandSubAccountsApi.prototype.deleteEnabledDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnabledDemandSubAccountsApiFp)(this.configuration).deleteEnabledDemandSubAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a demand sub account enablement
     * @summary Get a demand sub account enablement
     * @param {EnabledDemandSubAccountsApiGetEnabledDemandSubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnabledDemandSubAccountsApi
     */
    EnabledDemandSubAccountsApi.prototype.getEnabledDemandSubAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnabledDemandSubAccountsApiFp)(this.configuration).getEnabledDemandSubAccounts(requestParameters.limit, requestParameters.subAccountIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Replicate EnabledDemandSubAccounts
     * @summary Replicate EnabledDemandSubAccounts
     * @param {EnabledDemandSubAccountsApiGetEnabledDemandSubAccountsReplicationPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnabledDemandSubAccountsApi
     */
    EnabledDemandSubAccountsApi.prototype.getEnabledDemandSubAccountsReplicationPage = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnabledDemandSubAccountsApiFp)(this.configuration).getEnabledDemandSubAccountsReplicationPage(requestParameters.lastModified, requestParameters.id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnabledDemandSubAccountsApi;
}(base_1.BaseAPI));
exports.EnabledDemandSubAccountsApi = EnabledDemandSubAccountsApi;
/**
 * FeaturedDemandPartnersApi - axios parameter creator
 * @export
 */
var FeaturedDemandPartnersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete featured demand partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturedDemandPartner: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFeaturedDemandPartner', 'id', id);
                            localVarPath = "/featuredDemandPartners/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get featured demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedDemandPartners: function (supplySubAccountId, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplySubAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('getFeaturedDemandPartners', 'supplySubAccountId', supplySubAccountId);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getFeaturedDemandPartners', 'limit', limit);
                            localVarPath = "/featuredDemandPartners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A supply partner\'s featuredDemandPartners list. Overwrites the existing list if present.  The order will be preserved, with the first given id being associated with the top \'ranked\'  demand partner, and so on.
         * @summary Set a supply partner\'s list of featured demand partners
         * @param {FeaturedDemandPartnersCreate} featuredDemandPartnersCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedDemandPartners: function (featuredDemandPartnersCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'featuredDemandPartnersCreate' is not null or undefined
                            (0, common_1.assertParamExists)('setFeaturedDemandPartners', 'featuredDemandPartnersCreate', featuredDemandPartnersCreate);
                            localVarPath = "/featuredDemandPartners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(featuredDemandPartnersCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FeaturedDemandPartnersApiAxiosParamCreator = FeaturedDemandPartnersApiAxiosParamCreator;
/**
 * FeaturedDemandPartnersApi - functional programming interface
 * @export
 */
var FeaturedDemandPartnersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FeaturedDemandPartnersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete featured demand partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturedDemandPartner: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFeaturedDemandPartner(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get featured demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedDemandPartners: function (supplySubAccountId, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFeaturedDemandPartners(supplySubAccountId, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * A supply partner\'s featuredDemandPartners list. Overwrites the existing list if present.  The order will be preserved, with the first given id being associated with the top \'ranked\'  demand partner, and so on.
         * @summary Set a supply partner\'s list of featured demand partners
         * @param {FeaturedDemandPartnersCreate} featuredDemandPartnersCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedDemandPartners: function (featuredDemandPartnersCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFeaturedDemandPartners(featuredDemandPartnersCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FeaturedDemandPartnersApiFp = FeaturedDemandPartnersApiFp;
/**
 * FeaturedDemandPartnersApi - factory interface
 * @export
 */
var FeaturedDemandPartnersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FeaturedDemandPartnersApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete featured demand partner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeaturedDemandPartner: function (id, options) {
            return localVarFp.deleteFeaturedDemandPartner(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get featured demand partners
         * @param {Array<number>} supplySubAccountId A comma separated list of Supply Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedDemandPartners: function (supplySubAccountId, limit, options) {
            return localVarFp.getFeaturedDemandPartners(supplySubAccountId, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A supply partner\'s featuredDemandPartners list. Overwrites the existing list if present.  The order will be preserved, with the first given id being associated with the top \'ranked\'  demand partner, and so on.
         * @summary Set a supply partner\'s list of featured demand partners
         * @param {FeaturedDemandPartnersCreate} featuredDemandPartnersCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedDemandPartners: function (featuredDemandPartnersCreate, options) {
            return localVarFp.setFeaturedDemandPartners(featuredDemandPartnersCreate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FeaturedDemandPartnersApiFactory = FeaturedDemandPartnersApiFactory;
/**
 * FeaturedDemandPartnersApi - object-oriented interface
 * @export
 * @class FeaturedDemandPartnersApi
 * @extends {BaseAPI}
 */
var FeaturedDemandPartnersApi = /** @class */ (function (_super) {
    __extends(FeaturedDemandPartnersApi, _super);
    function FeaturedDemandPartnersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete featured demand partner
     * @param {FeaturedDemandPartnersApiDeleteFeaturedDemandPartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedDemandPartnersApi
     */
    FeaturedDemandPartnersApi.prototype.deleteFeaturedDemandPartner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FeaturedDemandPartnersApiFp)(this.configuration).deleteFeaturedDemandPartner(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get featured demand partners
     * @param {FeaturedDemandPartnersApiGetFeaturedDemandPartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedDemandPartnersApi
     */
    FeaturedDemandPartnersApi.prototype.getFeaturedDemandPartners = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FeaturedDemandPartnersApiFp)(this.configuration).getFeaturedDemandPartners(requestParameters.supplySubAccountId, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A supply partner\'s featuredDemandPartners list. Overwrites the existing list if present.  The order will be preserved, with the first given id being associated with the top \'ranked\'  demand partner, and so on.
     * @summary Set a supply partner\'s list of featured demand partners
     * @param {FeaturedDemandPartnersApiSetFeaturedDemandPartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedDemandPartnersApi
     */
    FeaturedDemandPartnersApi.prototype.setFeaturedDemandPartners = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FeaturedDemandPartnersApiFp)(this.configuration).setFeaturedDemandPartners(requestParameters.featuredDemandPartnersCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeaturedDemandPartnersApi;
}(base_1.BaseAPI));
exports.FeaturedDemandPartnersApi = FeaturedDemandPartnersApi;
/**
 * LifeInsuranceCarrierDetailsApi - axios parameter creator
 * @export
 */
var LifeInsuranceCarrierDetailsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get available life insurance Carrier details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceCarrierDetails: function (subAccountId, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'subAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('getLifeInsuranceCarrierDetails', 'subAccountId', subAccountId);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLifeInsuranceCarrierDetails', 'limit', limit);
                            localVarPath = "/lifeInsuranceCarrierDetails";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LifeInsuranceCarrierDetailsApiAxiosParamCreator = LifeInsuranceCarrierDetailsApiAxiosParamCreator;
/**
 * LifeInsuranceCarrierDetailsApi - functional programming interface
 * @export
 */
var LifeInsuranceCarrierDetailsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LifeInsuranceCarrierDetailsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get available life insurance Carrier details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceCarrierDetails: function (subAccountId, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLifeInsuranceCarrierDetails(subAccountId, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LifeInsuranceCarrierDetailsApiFp = LifeInsuranceCarrierDetailsApiFp;
/**
 * LifeInsuranceCarrierDetailsApi - factory interface
 * @export
 */
var LifeInsuranceCarrierDetailsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LifeInsuranceCarrierDetailsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get available life insurance Carrier details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceCarrierDetails: function (subAccountId, limit, options) {
            return localVarFp.getLifeInsuranceCarrierDetails(subAccountId, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LifeInsuranceCarrierDetailsApiFactory = LifeInsuranceCarrierDetailsApiFactory;
/**
 * LifeInsuranceCarrierDetailsApi - object-oriented interface
 * @export
 * @class LifeInsuranceCarrierDetailsApi
 * @extends {BaseAPI}
 */
var LifeInsuranceCarrierDetailsApi = /** @class */ (function (_super) {
    __extends(LifeInsuranceCarrierDetailsApi, _super);
    function LifeInsuranceCarrierDetailsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get available life insurance Carrier details of demand partners
     * @param {LifeInsuranceCarrierDetailsApiGetLifeInsuranceCarrierDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeInsuranceCarrierDetailsApi
     */
    LifeInsuranceCarrierDetailsApi.prototype.getLifeInsuranceCarrierDetails = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LifeInsuranceCarrierDetailsApiFp)(this.configuration).getLifeInsuranceCarrierDetails(requestParameters.subAccountId, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LifeInsuranceCarrierDetailsApi;
}(base_1.BaseAPI));
exports.LifeInsuranceCarrierDetailsApi = LifeInsuranceCarrierDetailsApi;
/**
 * LifeInsurancePolicyDetailsApi - axios parameter creator
 * @export
 */
var LifeInsurancePolicyDetailsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get available life insurance policy details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLifeInsurancePolicyDetails: function (subAccountId, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'subAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('getLifeInsurancePolicyDetails', 'subAccountId', subAccountId);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLifeInsurancePolicyDetails', 'limit', limit);
                            localVarPath = "/lifeInsurancePolicyDetails";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication internal required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication internal required
                            // http bearer authentication required
                            _a.sent();
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LifeInsurancePolicyDetailsApiAxiosParamCreator = LifeInsurancePolicyDetailsApiAxiosParamCreator;
/**
 * LifeInsurancePolicyDetailsApi - functional programming interface
 * @export
 */
var LifeInsurancePolicyDetailsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LifeInsurancePolicyDetailsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get available life insurance policy details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLifeInsurancePolicyDetails: function (subAccountId, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLifeInsurancePolicyDetails(subAccountId, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LifeInsurancePolicyDetailsApiFp = LifeInsurancePolicyDetailsApiFp;
/**
 * LifeInsurancePolicyDetailsApi - factory interface
 * @export
 */
var LifeInsurancePolicyDetailsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LifeInsurancePolicyDetailsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get available life insurance policy details of demand partners
         * @param {Array<number>} subAccountId A comma separated list of Demand Sub Account ids
         * @param {number} limit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLifeInsurancePolicyDetails: function (subAccountId, limit, options) {
            return localVarFp.getLifeInsurancePolicyDetails(subAccountId, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LifeInsurancePolicyDetailsApiFactory = LifeInsurancePolicyDetailsApiFactory;
/**
 * LifeInsurancePolicyDetailsApi - object-oriented interface
 * @export
 * @class LifeInsurancePolicyDetailsApi
 * @extends {BaseAPI}
 */
var LifeInsurancePolicyDetailsApi = /** @class */ (function (_super) {
    __extends(LifeInsurancePolicyDetailsApi, _super);
    function LifeInsurancePolicyDetailsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get available life insurance policy details of demand partners
     * @param {LifeInsurancePolicyDetailsApiGetLifeInsurancePolicyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof LifeInsurancePolicyDetailsApi
     */
    LifeInsurancePolicyDetailsApi.prototype.getLifeInsurancePolicyDetails = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LifeInsurancePolicyDetailsApiFp)(this.configuration).getLifeInsurancePolicyDetails(requestParameters.subAccountId, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LifeInsurancePolicyDetailsApi;
}(base_1.BaseAPI));
exports.LifeInsurancePolicyDetailsApi = LifeInsurancePolicyDetailsApi;
/**
 * StateExclusionApi - axios parameter creator
 * @export
 */
var StateExclusionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a state exclusion
         * @summary Create a state exclusion
         * @param {StateExclusionCreateData} [stateExclusionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStateExclusion: function (stateExclusionCreateData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/stateExclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stateExclusionCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a state exclusion
         * @summary Delete a state exclusion
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStateExclusion: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteStateExclusion', 'id', id);
                            localVarPath = "/stateExclusions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get state exclusions
         * @summary Get state exclusions
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [stateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusions: function (id, demandSubAccountId, stateCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/stateExclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (stateCode) {
                                localVarQueryParameter['stateCode'] = stateCode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Replicate StateExclusions
         * @summary Replicate StateExclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusionsReplicationPage: function (lastModified, id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'lastModified' is not null or undefined
                            (0, common_1.assertParamExists)('getStateExclusionsReplicationPage', 'lastModified', lastModified);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStateExclusionsReplicationPage', 'id', id);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getStateExclusionsReplicationPage', 'limit', limit);
                            localVarPath = "/replication/stateExclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (lastModified !== undefined) {
                                localVarQueryParameter['lastModified'] = (lastModified instanceof Date) ?
                                    lastModified.toISOString() :
                                    lastModified;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StateExclusionApiAxiosParamCreator = StateExclusionApiAxiosParamCreator;
/**
 * StateExclusionApi - functional programming interface
 * @export
 */
var StateExclusionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StateExclusionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a state exclusion
         * @summary Create a state exclusion
         * @param {StateExclusionCreateData} [stateExclusionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStateExclusion: function (stateExclusionCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createStateExclusion(stateExclusionCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a state exclusion
         * @summary Delete a state exclusion
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStateExclusion: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStateExclusion(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get state exclusions
         * @summary Get state exclusions
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [stateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusions: function (id, demandSubAccountId, stateCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStateExclusions(id, demandSubAccountId, stateCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Replicate StateExclusions
         * @summary Replicate StateExclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusionsReplicationPage: function (lastModified, id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStateExclusionsReplicationPage(lastModified, id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.StateExclusionApiFp = StateExclusionApiFp;
/**
 * StateExclusionApi - factory interface
 * @export
 */
var StateExclusionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StateExclusionApiFp)(configuration);
    return {
        /**
         * Create a state exclusion
         * @summary Create a state exclusion
         * @param {StateExclusionCreateData} [stateExclusionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStateExclusion: function (stateExclusionCreateData, options) {
            return localVarFp.createStateExclusion(stateExclusionCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a state exclusion
         * @summary Delete a state exclusion
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStateExclusion: function (id, options) {
            return localVarFp.deleteStateExclusion(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get state exclusions
         * @summary Get state exclusions
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [stateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusions: function (id, demandSubAccountId, stateCode, options) {
            return localVarFp.getStateExclusions(id, demandSubAccountId, stateCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Replicate StateExclusions
         * @summary Replicate StateExclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateExclusionsReplicationPage: function (lastModified, id, limit, options) {
            return localVarFp.getStateExclusionsReplicationPage(lastModified, id, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StateExclusionApiFactory = StateExclusionApiFactory;
/**
 * StateExclusionApi - object-oriented interface
 * @export
 * @class StateExclusionApi
 * @extends {BaseAPI}
 */
var StateExclusionApi = /** @class */ (function (_super) {
    __extends(StateExclusionApi, _super);
    function StateExclusionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a state exclusion
     * @summary Create a state exclusion
     * @param {StateExclusionApiCreateStateExclusionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateExclusionApi
     */
    StateExclusionApi.prototype.createStateExclusion = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StateExclusionApiFp)(this.configuration).createStateExclusion(requestParameters.stateExclusionCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a state exclusion
     * @summary Delete a state exclusion
     * @param {StateExclusionApiDeleteStateExclusionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateExclusionApi
     */
    StateExclusionApi.prototype.deleteStateExclusion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StateExclusionApiFp)(this.configuration).deleteStateExclusion(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get state exclusions
     * @summary Get state exclusions
     * @param {StateExclusionApiGetStateExclusionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateExclusionApi
     */
    StateExclusionApi.prototype.getStateExclusions = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StateExclusionApiFp)(this.configuration).getStateExclusions(requestParameters.id, requestParameters.demandSubAccountId, requestParameters.stateCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Replicate StateExclusions
     * @summary Replicate StateExclusions
     * @param {StateExclusionApiGetStateExclusionsReplicationPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateExclusionApi
     */
    StateExclusionApi.prototype.getStateExclusionsReplicationPage = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StateExclusionApiFp)(this.configuration).getStateExclusionsReplicationPage(requestParameters.lastModified, requestParameters.id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StateExclusionApi;
}(base_1.BaseAPI));
exports.StateExclusionApi = StateExclusionApi;
/**
 * SupplyDemandInclusionApi - axios parameter creator
 * @export
 */
var SupplyDemandInclusionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a supply / demand inclusion
         * @summary Create a supply / demand inclusion
         * @param {SupplyDemandInclusionCreateData} supplyDemandInclusionCreateData A Supply Demand Inclusion object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandInclusion: function (supplyDemandInclusionCreateData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplyDemandInclusionCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createSupplyDemandInclusion', 'supplyDemandInclusionCreateData', supplyDemandInclusionCreateData);
                            localVarPath = "/supplyDemandInclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyDemandInclusionCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply / demand inclusion
         * @summary Delete a supply / demand inclusion
         * @param {number} id
         * @param {SupplyDemandInclusionDelete} supplyDemandInclusionDelete A Supply Demand Inclusion Delete object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandInclusion: function (id, supplyDemandInclusionDelete, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyDemandInclusion', 'id', id);
                            // verify required parameter 'supplyDemandInclusionDelete' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyDemandInclusion', 'supplyDemandInclusionDelete', supplyDemandInclusionDelete);
                            localVarPath = "/supplyDemandInclusions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyDemandInclusionDelete, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return supply / demand inclusions based on request parameters
         * @summary Get supply / demand inclusions
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of demand sub account ids
         * @param {Array<number>} [supplySubAccountId] A comma separated list of supply sub account ids
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusions: function (limit, id, demandSubAccountId, supplySubAccountId, isDeleted, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyDemandInclusions', 'limit', limit);
                            localVarPath = "/supplyDemandInclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["partner-data:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Replicate SupplyDemandInclusions
         * @summary Replicate SupplyDemandInclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusionsReplicationPage: function (lastModified, id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'lastModified' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyDemandInclusionsReplicationPage', 'lastModified', lastModified);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyDemandInclusionsReplicationPage', 'id', id);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyDemandInclusionsReplicationPage', 'limit', limit);
                            localVarPath = "/replication/supplyDemandInclusions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["internal"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (lastModified !== undefined) {
                                localVarQueryParameter['lastModified'] = (lastModified instanceof Date) ?
                                    lastModified.toISOString() :
                                    lastModified;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandInclusionApiAxiosParamCreator = SupplyDemandInclusionApiAxiosParamCreator;
/**
 * SupplyDemandInclusionApi - functional programming interface
 * @export
 */
var SupplyDemandInclusionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyDemandInclusionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a supply / demand inclusion
         * @summary Create a supply / demand inclusion
         * @param {SupplyDemandInclusionCreateData} supplyDemandInclusionCreateData A Supply Demand Inclusion object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandInclusion: function (supplyDemandInclusionCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyDemandInclusion(supplyDemandInclusionCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a supply / demand inclusion
         * @summary Delete a supply / demand inclusion
         * @param {number} id
         * @param {SupplyDemandInclusionDelete} supplyDemandInclusionDelete A Supply Demand Inclusion Delete object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandInclusion: function (id, supplyDemandInclusionDelete, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyDemandInclusion(id, supplyDemandInclusionDelete, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Return supply / demand inclusions based on request parameters
         * @summary Get supply / demand inclusions
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of demand sub account ids
         * @param {Array<number>} [supplySubAccountId] A comma separated list of supply sub account ids
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusions: function (limit, id, demandSubAccountId, supplySubAccountId, isDeleted, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyDemandInclusions(limit, id, demandSubAccountId, supplySubAccountId, isDeleted, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Replicate SupplyDemandInclusions
         * @summary Replicate SupplyDemandInclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusionsReplicationPage: function (lastModified, id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyDemandInclusionsReplicationPage(lastModified, id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandInclusionApiFp = SupplyDemandInclusionApiFp;
/**
 * SupplyDemandInclusionApi - factory interface
 * @export
 */
var SupplyDemandInclusionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyDemandInclusionApiFp)(configuration);
    return {
        /**
         * Create a supply / demand inclusion
         * @summary Create a supply / demand inclusion
         * @param {SupplyDemandInclusionCreateData} supplyDemandInclusionCreateData A Supply Demand Inclusion object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandInclusion: function (supplyDemandInclusionCreateData, options) {
            return localVarFp.createSupplyDemandInclusion(supplyDemandInclusionCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply / demand inclusion
         * @summary Delete a supply / demand inclusion
         * @param {number} id
         * @param {SupplyDemandInclusionDelete} supplyDemandInclusionDelete A Supply Demand Inclusion Delete object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandInclusion: function (id, supplyDemandInclusionDelete, options) {
            return localVarFp.deleteSupplyDemandInclusion(id, supplyDemandInclusionDelete, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return supply / demand inclusions based on request parameters
         * @summary Get supply / demand inclusions
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [demandSubAccountId] A comma separated list of demand sub account ids
         * @param {Array<number>} [supplySubAccountId] A comma separated list of supply sub account ids
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusions: function (limit, id, demandSubAccountId, supplySubAccountId, isDeleted, offset, options) {
            return localVarFp.getSupplyDemandInclusions(limit, id, demandSubAccountId, supplySubAccountId, isDeleted, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Replicate SupplyDemandInclusions
         * @summary Replicate SupplyDemandInclusions
         * @param {Date} lastModified creation date of object
         * @param {number} id id of record to replicate from
         * @param {number} limit The maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandInclusionsReplicationPage: function (lastModified, id, limit, options) {
            return localVarFp.getSupplyDemandInclusionsReplicationPage(lastModified, id, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyDemandInclusionApiFactory = SupplyDemandInclusionApiFactory;
/**
 * SupplyDemandInclusionApi - object-oriented interface
 * @export
 * @class SupplyDemandInclusionApi
 * @extends {BaseAPI}
 */
var SupplyDemandInclusionApi = /** @class */ (function (_super) {
    __extends(SupplyDemandInclusionApi, _super);
    function SupplyDemandInclusionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a supply / demand inclusion
     * @summary Create a supply / demand inclusion
     * @param {SupplyDemandInclusionApiCreateSupplyDemandInclusionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandInclusionApi
     */
    SupplyDemandInclusionApi.prototype.createSupplyDemandInclusion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandInclusionApiFp)(this.configuration).createSupplyDemandInclusion(requestParameters.supplyDemandInclusionCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply / demand inclusion
     * @summary Delete a supply / demand inclusion
     * @param {SupplyDemandInclusionApiDeleteSupplyDemandInclusionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandInclusionApi
     */
    SupplyDemandInclusionApi.prototype.deleteSupplyDemandInclusion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandInclusionApiFp)(this.configuration).deleteSupplyDemandInclusion(requestParameters.id, requestParameters.supplyDemandInclusionDelete, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return supply / demand inclusions based on request parameters
     * @summary Get supply / demand inclusions
     * @param {SupplyDemandInclusionApiGetSupplyDemandInclusionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandInclusionApi
     */
    SupplyDemandInclusionApi.prototype.getSupplyDemandInclusions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandInclusionApiFp)(this.configuration).getSupplyDemandInclusions(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.supplySubAccountId, requestParameters.isDeleted, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Replicate SupplyDemandInclusions
     * @summary Replicate SupplyDemandInclusions
     * @param {SupplyDemandInclusionApiGetSupplyDemandInclusionsReplicationPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandInclusionApi
     */
    SupplyDemandInclusionApi.prototype.getSupplyDemandInclusionsReplicationPage = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandInclusionApiFp)(this.configuration).getSupplyDemandInclusionsReplicationPage(requestParameters.lastModified, requestParameters.id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyDemandInclusionApi;
}(base_1.BaseAPI));
exports.SupplyDemandInclusionApi = SupplyDemandInclusionApi;
